import { useParams, useLocation } from "react-router-dom";
import { Language } from "@/contexts/LanguageContext";

const SUPPORTED_LANGUAGES: Language[] = ["pt", "en", "es", "fr", "zh"];

export const getLanguageFromPath = (pathname: string): Language | null => {
  const segments = pathname.split("/").filter(Boolean);
  const firstSegment = segments[0];
  
  if (firstSegment && SUPPORTED_LANGUAGES.includes(firstSegment as Language)) {
    return firstSegment as Language;
  }
  
  return null;
};

export const getPathWithoutLanguage = (pathname: string): string => {
  const segments = pathname.split("/").filter(Boolean);
  const firstSegment = segments[0];
  
  if (firstSegment && SUPPORTED_LANGUAGES.includes(firstSegment as Language)) {
    return "/" + segments.slice(1).join("/");
  }
  
  return pathname;
};

export const getPathWithLanguage = (pathname: string, lang: Language): string => {
  const pathWithoutLang = getPathWithoutLanguage(pathname);
  
  // For Portuguese (default), we can use root path
  if (lang === "pt") {
    return pathWithoutLang || "/";
  }
  
  // For other languages, prefix with language code
  if (pathWithoutLang === "/" || pathWithoutLang === "") {
    return `/${lang}`;
  }
  
  return `/${lang}${pathWithoutLang}`;
};

export const useLanguageFromUrl = (): {
  urlLanguage: Language | null;
  currentPath: string;
} => {
  const location = useLocation();
  const urlLanguage = getLanguageFromPath(location.pathname);
  const currentPath = getPathWithoutLanguage(location.pathname);
  
  return { urlLanguage, currentPath };
};
